// app/javascript/controllers/digit_mask_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { max: { type: Number, default: 4 } }

  connect() {
    this.element.addEventListener("input", this.mask.bind(this))
    this.element.addEventListener("keydown", this.preventNonDigit.bind(this))
  }

  mask(e) {
    let v = e.target.value.replace(/\D/g, "")
    if (v.length > this.maxValue) v = v.slice(0, this.maxValue)
    e.target.value = v
  }

  preventNonDigit(e) {
    if (e.key.length === 1 && !/\d/.test(e.key) && !e.ctrlKey && !e.metaKey) {
      e.preventDefault()
    }
  }
}
